import i18n from 'i18next';

// eslint-disable-next-line import/prefer-default-export
export const buildInvalidFieldTranslation = (
  fieldNameTranslationKey: string,
) => i18n.t('validation.invalidField', { fieldName: i18n.t(fieldNameTranslationKey) });
